export default function gameApiPath(path: string, params: any) {
  const countryPath = params.multiId
    ? `${params.serverId}-${params.multiId}`
    : `${params.serverId}`;
  return `/${countryPath}/${path}`;
}
